export default [
  {
    path: "/campaigns",
    component: () => import(/* webpackChunkName: "campaigns" */ "./layout"),

    children: [
      {
        path: "/",
        name: "campaigns",
        component: () => import(/* webpackChunkName: "campaigns.index" */ "./index"),
      },
      {
        path: ":id",
        props: true,
        name: "campaigns.show",
        component: () => import(/* webpackChunkName: "campaigns.show" */ "./show"),
      },
    ],
  },
];
